import { render } from "./AssetDetail.vue?vue&type=template&id=246803a2&scoped=true"
import script from "./AssetDetail.vue?vue&type=script&lang=js"
export * from "./AssetDetail.vue?vue&type=script&lang=js"

import "./AssetDetail.vue?vue&type=style&index=0&id=246803a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246803a2"]])

export default __exports__